
import XHeader from 'vux/src/components/x-header/index.vue'

import api from "~api";
export default {
name: "applicationProfessionalTransfer",
components: {
XHeader
},
data(){
return{
title: "专业咨询",
list: '',
}
},
mounted(){
},
methods:{
notice(){
this.$router.push({name:'noticeTransfer'})
},
apply(){
const _this = this
let parms = {
"stuCode": window.localStorage.getItem("stuCode"),
"deptIdNew":""
}
api.post('/api/changeMajor/findStuInfo',parms).then(function (response) {
if(response.status===200){
if(response.data.code!=='1'){
_this.$msgbox('温馨提示：',response.data.message);
}else {
_this.$router.push({name:'noticeApply'})
}
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})

},
myApply(){
this.$router.push({name:'myNoticeApply'})
}
}
}



// WEBPACK FOOTER //
// ./src/components/applicationProfessionalTransfer.vue